import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { PrimaryButton } from 'office-ui-fabric-react';
import TextButton from '../../components/TextButton';
import BundleForm from '../../components/BundleForm';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './AddBundle.style';

const AddBundle = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaveEnable, setIsSaveEnable] = useState(false);
  const [showAllocationError, setShowAllocationError] = useState(false);
  const [isAllocationError, setIsAllocationError] = useState(false);
  const history = useHistory();
  const ref = useRef();

  const handleCancel = () => {
    history.push({ pathname: '/products', state: { tabName: 'bundles' } });
  };

  const handleUpdate = isEnable => {
    setIsSaveEnable(isEnable);
  };

  const handleSave = async () => {
    if (!showAllocationError) {
      if (isAllocationError) {
        await ref.current.validateForm();
        setShowAllocationError(true);
      } else {
        setIsSubmitting(true);

        await ref.current.submitForm();
        if (ref.current && !isEmpty(ref.current.errors)) {
          if (ref.current.errors?.componentAllocationPercentage) {
            setShowAllocationError(true);
          }
          setIsSubmitting(false);
        }
      }
    } else if (ref.current && isEmpty(ref.current.errors)) {
      await ref.current.validateForm();
    }
  };

  const handleAllocationChange = (showError, hasError) => {
    setShowAllocationError(showError);
    setIsAllocationError(hasError);
  };

  const handleSuccess = bundle => {
    history.push(`/bundles/${bundle.bundleId}`);
  };

  return (
    <>
      <PageTitle>Add Bundle</PageTitle>

      <Main>
        <Module>
          <ModuleContent>
            <BundleForm
              ref={ref}
              onUpdate={handleUpdate}
              onSuccess={handleSuccess}
              showAllocationError={showAllocationError}
              setShowAllocationError={handleAllocationChange}
            />
          </ModuleContent>
        </Module>

        <div className={styles.buttonContainer}>
          <TextButton
            className={styles.cancelButton}
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </TextButton>
          {!isSubmitting ? (
            <PrimaryButton
              type="submit"
              onClick={handleSave}
              disabled={isSubmitting || !isSaveEnable}
            >
              Save
            </PrimaryButton>
          ) : (
            <SavingIndicator />
          )}
        </div>
      </Main>
    </>
  );
};

export default AddBundle;
